import Oidc from "oidc-client";
const provideUserManager = () => {
    const userManager = new Oidc.UserManager({
        authority: "https://login.baogaoting.com",
        // authority: "http://192.168.2.146:81",
        // client_id: "hNkp24OvyJispa", //client_id：表示客户端的ID，必选项
        client_id: "Y9m6sUmE590S4O",
        redirect_uri: "https://chart.baogaoting.com/oidc-callback", //redirect_uri：表示重定向URI，可选项
        // redirect_uri: "http://192.168.2.84:8080/oidc-callback",
        post_logout_redirect_uri: 'https://chart.baogaoting.com',
        // post_logout_redirect_uri: 'http://192.168.2.84:8080',
        response_type: "id_token token", // response_type：表示授权类型，必选项
        userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
        scope: "r.webapi openid profile", //scope：表示申请的权限范围，可选项
        automaticSilentRenew: true,
    });
    return userManager;
};

export default provideUserManager;